(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4111,7797,5783,56012,75978,91058,99257,59654,55004,6050,12701,59679,68837,54223,6169,13054,59544,54042,19341,97,33030],{

/***/ 10928:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 41910:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/works/[project]",
      function () {
        return __webpack_require__(38175);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 38175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _project_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/CaseStudiesCommon/index.jsx






var IntroRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(19528), __webpack_require__.e(2610)]).then(__webpack_require__.bind(__webpack_require__, 25631));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25631)
            ];
        }
    }
});
var ProjectIdeaRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(41232)]).then(__webpack_require__.bind(__webpack_require__, 4557));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4557)
            ];
        }
    }
});
var ResultsSectionRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(22250), __webpack_require__.e(40659)]).then(__webpack_require__.bind(__webpack_require__, 51781));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51781)
            ];
        }
    }
});
var ImagesSectionRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(83628), __webpack_require__.e(81066)]).then(__webpack_require__.bind(__webpack_require__, 53435));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53435)
            ];
        }
    }
});
var WireframesSectionRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(8538), __webpack_require__.e(75847)]).then(__webpack_require__.bind(__webpack_require__, 64757));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64757)
            ];
        }
    }
});
var SpecialChallengesAndSolutionsRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(43289), __webpack_require__.e(18089)]).then(__webpack_require__.bind(__webpack_require__, 20597));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20597)
            ];
        }
    }
});
var ChallengesAndSolutionsWithWireframesRefactored = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(43289), __webpack_require__.e(26174), __webpack_require__.e(34359)]).then(__webpack_require__.bind(__webpack_require__, 75033));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75033)
            ];
        }
    }
});
var CaseParallax = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(88840), __webpack_require__.e(12554)]).then(__webpack_require__.bind(__webpack_require__, 97736));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97736)
            ];
        }
    }
});
var CaseStudyDesign = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(59425)]).then(__webpack_require__.bind(__webpack_require__, 95778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95778)
            ];
        }
    }
});
var CaseAppFeatures = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(96563)]).then(__webpack_require__.bind(__webpack_require__, 6310));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6310)
            ];
        }
    }
});
var CaseFeaturesSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(21442)]).then(__webpack_require__.bind(__webpack_require__, 90226));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90226)
            ];
        }
    }
});
var CaseFullScreenImages = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(37083)]).then(__webpack_require__.bind(__webpack_require__, 95734));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95734)
            ];
        }
    }
});
var CaseEvent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(95739)]).then(__webpack_require__.bind(__webpack_require__, 85586));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85586)
            ];
        }
    }
});
var CaseStudiesStory = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(95791)]).then(__webpack_require__.bind(__webpack_require__, 95791));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95791)
            ];
        }
    }
});
var CaseProcess = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(48521), __webpack_require__.e(44709)]).then(__webpack_require__.bind(__webpack_require__, 96366));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96366)
            ];
        }
    }
});
var CasePrototype = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(63518)]).then(__webpack_require__.bind(__webpack_require__, 19785));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19785)
            ];
        }
    }
});
var CaseFeedback = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(87375)]).then(__webpack_require__.bind(__webpack_require__, 99839));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99839)
            ];
        }
    }
});
var CardsSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(2013), __webpack_require__.e(40852)]).then(__webpack_require__.bind(__webpack_require__, 90058));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90058)
            ];
        }
    }
});
var ProcessSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(70600), __webpack_require__.e(15805), __webpack_require__.e(95436), __webpack_require__.e(81243)]).then(__webpack_require__.bind(__webpack_require__, 35845));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35845)
            ];
        }
    }
});
var TabsSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(13971), __webpack_require__.e(74453)]).then(__webpack_require__.bind(__webpack_require__, 76974));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76974)
            ];
        }
    }
});
var FaqSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(49119), __webpack_require__.e(8939)]).then(__webpack_require__.bind(__webpack_require__, 65016));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65016)
            ];
        }
    }
});
var PlainTextSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(46680), __webpack_require__.e(83509), __webpack_require__.e(44954)]).then(__webpack_require__.bind(__webpack_require__, 57149));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57149)
            ];
        }
    }
});
var CaseAccordion = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(98885), __webpack_require__.e(61793), __webpack_require__.e(15805), __webpack_require__.e(46661)]).then(__webpack_require__.bind(__webpack_require__, 88181));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88181)
            ];
        }
    }
});
var TwoBlockChallanges = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(43289), __webpack_require__.e(7859)]).then(__webpack_require__.bind(__webpack_require__, 20325));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20325)
            ];
        }
    }
});
var SliderSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(82765), __webpack_require__.e(40617)]).then(__webpack_require__.bind(__webpack_require__, 55410));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55410)
            ];
        }
    }
});
var CaseStudiesCommon = function(_param) {
    var section = _param.section, props = (0,_object_without_properties/* default */.Z)(_param, [
        "section"
    ]);
    switch(props.data.type){
        case constants/* CASE_STUDIES_TYPES.intro */.vA.intro:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.projectIdea */.vA.projectIdea:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectIdeaRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.results */.vA.results:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultsSectionRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.appFeatures */.vA.appFeatures:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseAppFeatures, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.image */.vA.image:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagesSectionRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.wireframe */.vA.wireframe:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WireframesSectionRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.specialChallenges */.vA.specialChallenges:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialChallengesAndSolutionsRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.challenges */.vA.challenges:
        case constants/* CASE_STUDIES_TYPES.challengesSlider */.vA.challengesSlider:
        case constants/* CASE_STUDIES_TYPES.challengesSpecialSlider */.vA.challengesSpecialSlider:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChallengesAndSolutionsWithWireframesRefactored, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.parallax */.vA.parallax:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseParallax, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.feedback */.vA.feedback:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseFeedback, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.design */.vA.design:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudyDesign, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.features */.vA.features:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseFeaturesSection, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.fullscreenImage */.vA.fullscreenImage:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseFullScreenImages, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.caseStudyEvent */.vA.caseStudyEvent:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseEvent, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.story */.vA.story:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudiesStory, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.process */.vA.process:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseProcess, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.prototype */.vA.prototype:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CasePrototype, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.cards */.vA.cards:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSection, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.tabs */.vA.tabs:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsSection, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.cardsWithOverlay */.vA.cardsWithOverlay:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                withOverlay: true
            }));
        case constants/* CASE_STUDIES_TYPES.processWithArrays */.vA.processWithArrays:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProcessSection, (0,_object_spread/* default */.Z)({}, props));
        case constants/* CASE_STUDIES_TYPES.faq */.vA.faq:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                section: section
            }));
        case constants/* CASE_STUDIES_TYPES.plainTextSection */.vA.plainTextSection:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainTextSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                section: section
            }));
        case constants/* CASE_STUDIES_TYPES.accordionCards */.vA.accordionCards:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseAccordion, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                section: section
            }));
        case constants/* CASE_STUDIES_TYPES.twoBlockChallanges */.vA.twoBlockChallanges:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoBlockChallanges, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                section: section
            }));
        case constants/* CASE_STUDIES_TYPES.slider */.vA.slider:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderSection, (0,_object_spread/* default */.Z)({
                sectionData: section
            }, props));
        default:
            return null;
    }
};
/* harmony default export */ var components_CaseStudiesCommon = (CaseStudiesCommon);

// EXTERNAL MODULE: ./components/Common/MetaTags/index.jsx + 3 modules
var MetaTags = __webpack_require__(38067);
// EXTERNAL MODULE: ./UI/components/AiEngineeringPodBadge/index.jsx
var AiEngineeringPodBadge = __webpack_require__(96038);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/routes.js
var routes = __webpack_require__(27727);
// EXTERNAL MODULE: ./redux/apis/page.js
var page = __webpack_require__(85144);
// EXTERNAL MODULE: ./utils/breadcrumbs.js
var utils_breadcrumbs = __webpack_require__(84047);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./containers/CaseStudies/styles.module.scss
var styles_module = __webpack_require__(18907);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./utils/constants/contacts.js
var contacts = __webpack_require__(32522);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/last.js
var last = __webpack_require__(10928);
var last_default = /*#__PURE__*/__webpack_require__.n(last);
;// CONCATENATED MODULE: ./UI/sections/CaseStudiesFooter/utils/data.js

var data_socialNetworks = Object.values(contacts/* SOCIAL_MEDIA */.CL).filter(function(param) {
    var id = param.id;
    return [
        "behance",
        "dribbble",
        "instagram", 
    ].includes(id);
});
var CASES_BLACK_ICONS = [
    "open-sense",
    "tell"
];

;// CONCATENATED MODULE: ./UI/sections/CaseStudiesFooter/utils/useCaseStudiesFooter.js





var useCaseStudiesFooter = function(param) {
    var type = param.type, pathname = param.pathname;
    var ref = (0,page/* useFetchPageQuery */.oO)(type), tmp = ref.data, contentModules = (tmp === void 0 ? {} : tmp).contentModules;
    var lastContentModule = last_default()(contentModules);
    var ref1 = (0,helper/* getDocumentFields */.OA)(lastContentModule, [
        "background",
        "contentModules"
    ]), background = ref1.background, footerContentModules = ref1.contentModules;
    var ref2 = (0,helper/* getDocumentFields */.OA)(get_default()(footerContentModules, "[0]", {}), [
        "title",
        "buttonTitle",
        "slug", 
    ]), title = ref2.title, buttonTitle = ref2.buttonTitle, slug = ref2.slug;
    var footerBackgroundImage = (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(background), {
        fm: "png"
    });
    var footerStyle = footerBackgroundImage ? {
        backgroundImage: "url(".concat(footerBackgroundImage, ")")
    } : {};
    var socialNetworks = data_socialNetworks.map(function(item) {
        return {
            name: item.title,
            icon: CASES_BLACK_ICONS.includes(type) ? item.iconDark : item.iconLight,
            href: item.link
        };
    });
    return {
        type: type,
        title: title,
        buttonTitle: buttonTitle,
        slug: slug,
        pathname: pathname,
        footerStyle: footerStyle,
        socialNetworks: socialNetworks
    };
};

// EXTERNAL MODULE: ./UI/sections/CaseStudiesFooter/styles.module.scss
var CaseStudiesFooter_styles_module = __webpack_require__(6893);
var CaseStudiesFooter_styles_module_default = /*#__PURE__*/__webpack_require__.n(CaseStudiesFooter_styles_module);
;// CONCATENATED MODULE: ./UI/sections/CaseStudiesFooter/index.jsx










var SectionTitle = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(15811)]).then(__webpack_require__.bind(__webpack_require__, 15805));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15805)
            ];
        }
    }
});
var Svg = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var CaseStudiesFooter = function(props) {
    var ref = useCaseStudiesFooter(props), type = ref.type, title = ref.title, buttonTitle = ref.buttonTitle, slug = ref.slug, pathname = ref.pathname, footerStyle = ref.footerStyle, socialNetworks = ref.socialNetworks;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: classnames_default()((CaseStudiesFooter_styles_module_default())[type], (CaseStudiesFooter_styles_module_default()).footer),
        style: footerStyle,
        children: [
            slug && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CaseStudiesFooter_styles_module_default()).nextProjectContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
                        title: "Next project",
                        description: title,
                        className: (CaseStudiesFooter_styles_module_default()).sectionTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkWrapper/* default */.Z, {
                        path: slug,
                        className: (CaseStudiesFooter_styles_module_default()).more,
                        isLocalLink: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                className: (CaseStudiesFooter_styles_module_default()).textIndent,
                                children: buttonTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                                type: constants/* SVG_IMAGES_TYPES.arrow */.NL.arrow
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CaseStudiesFooter_styles_module_default()).footerLinks,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CaseStudiesFooter_styles_module_default()).emailContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                variant: "p",
                                className: (CaseStudiesFooter_styles_module_default()).question,
                                children: "Not sure where to start?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                path: "mailto:".concat(contacts/* EMAIL_LINK */.Vr),
                                className: (CaseStudiesFooter_styles_module_default()).link,
                                isLocalLink: true,
                                googleAnalyticProps: {
                                    action: "Click",
                                    data: "Email"
                                },
                                children: contacts/* EMAIL_LINK */.Vr
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: socialNetworks.map(function(param) {
                            var name = param.name, href = param.href, icon = param.icon;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                path: href,
                                className: (CaseStudiesFooter_styles_module_default()).iconLink,
                                googleAnalyticProps: {
                                    category: "Social",
                                    label: pathname,
                                    data: name
                                },
                                isSocialLink: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                                    type: icon
                                })
                            }, "networks/".concat(name));
                        })
                    })
                ]
            })
        ]
    });
};
CaseStudiesFooter.propTypes = {
    type: (prop_types_default()).string.isRequired,
    pathname: (prop_types_default()).string.isRequired
};
/* harmony default export */ var sections_CaseStudiesFooter = (CaseStudiesFooter);

;// CONCATENATED MODULE: ./containers/CaseStudies/index.jsx














var CaseStudiesContainer = function(param) {
    var introSection = param.introSection, slug = param.slug;
    var ref = (0,page/* useFetchPageQuery */.oO)(slug), _data = ref.data, data = _data === void 0 ? {} : _data, isLoading = ref.isLoading;
    var asPath = (0,router.useRouter)().asPath;
    if (isLoading) {
        return null;
    }
    var contentModules = data.contentModules, pageTitle = data.pageTitle, _metaData = data.metaData, metaTitle = _metaData.metaTitle, metaDescription = _metaData.metaDescription, ogImage = _metaData.ogImage, metaRobots = _metaData.metaRobots;
    var projectMetadata = {
        metaTitle: metaTitle || "".concat(pageTitle, " | Yellow"),
        metaDescription: metaDescription || pageTitle && "Yellow professionals have created ".concat(pageTitle, ". Read our case study to find more!"),
        url: "".concat(helper/* rootUrl */.Wd).concat(routes/* routes.portfolio.getRoute */._.portfolio.getRoute(slug).path),
        metaRobots: metaRobots,
        ogImage: ogImage
    };
    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! DONT FORGET TO USE IT DURING RESOLVING MERGE CONFLICT !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    var breadcrumbs = (0,utils_breadcrumbs/* getBreadcrumbs */.Z)(constants/* PAGES.project */.q5.project, {
        slug: slug,
        title: pageTitle
    });
    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! DONT FORGET TO USE IT DURING RESOLVING MERGE CONFLICT !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    var breadcrumbsTheme = constants/* PAGES_WITH_DARK_BREADCRUMBS.includes */.nq.includes(slug) ? "dark" : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                page: constants/* PAGES.portfolio */.q5.portfolio,
                pageMetadata: projectMetadata,
                breadcrumbs: breadcrumbs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: classnames_default()((styles_module_default()).main, (styles_module_default())[slug]),
                children: [
                    contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(contentModule) {
                        var fields = contentModule.fields, sys = contentModule.sys;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CaseStudiesCommon, {
                            type: slug,
                            introSection: introSection,
                            section: contentModule,
                            data: fields,
                            breadcrumbs: breadcrumbs,
                            breadcrumbsTheme: breadcrumbsTheme
                        }, sys.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_CaseStudiesFooter, {
                        type: slug,
                        pathname: asPath
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AiEngineeringPodBadge/* default */.Z, {})
                ]
            })
        ]
    });
};
CaseStudiesContainer.propTypes = {
    introSection: prop_types_default().instanceOf(Object).isRequired
};
/* harmony default export */ var CaseStudies = (CaseStudiesContainer);

;// CONCATENATED MODULE: ./pages/works/[project].js




var Project = function(_param) /*#__PURE__*/ {
    var introSection = _param.introSection, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "introSection"
    ]);
    return (0,jsx_runtime.jsx)(CaseStudies, (0,_object_spread/* default */.Z)({
        introSection: introSection
    }, rest));
};
var __N_SSG = true;
/* harmony default export */ var _project_ = (Project);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 6893:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__PFWKN","contentWrapper":"styles_contentWrapper__xTBVi","nextProjectContainer":"styles_nextProjectContainer__solM4","sectionTitle":"styles_sectionTitle__zQvM7","more":"styles_more__ZD027","question":"styles_question__DDOsx","link":"styles_link__xsQEV","iconLink":"styles_iconLink__S15zr","footerLinks":"styles_footerLinks__TW_BU","emailContainer":"styles_emailContainer__ZYbuJ","stickerbox":"styles_stickerbox__Gd3Rs","fireaway":"styles_fireaway__jvfn7","fairy":"styles_fairy__tCAVG","seven-pm-thursday":"styles_seven-pm-thursday__txsuI","fernwayer":"styles_fernwayer__9yOjO","drive-focus":"styles_drive-focus__IUsnh","hotel-data-cloud":"styles_hotel-data-cloud__lr_K8","open-sense":"styles_open-sense__mouoE","separate-us":"styles_separate-us__ccQtZ","famlicious":"styles_famlicious__dnBmg","natp":"styles_natp__aioJt","travel-trivia":"styles_travel-trivia__HFF4Q","cash-chat":"styles_cash-chat__Fx_Gk","tell":"styles_tell__smGtq","ubichat":"styles_ubichat__c_tfe","writer-chrome-extension":"styles_writer-chrome-extension__yfShI","meateater":"styles_meateater__tv4TS","bionorica":"styles_bionorica__Xw4bH","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__ltq_M","fusion-markets":"styles_fusion-markets__HznRX","beautonomy":"styles_beautonomy__xPlVv","telemojo":"styles_telemojo__mH_jZ","blackbird":"styles_blackbird__UIWRH","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__8aVws","smartcenter":"styles_smartcenter__Dft52","dindon":"styles_dindon__P3O4u","humankind":"styles_humankind__mfqIK","cinnabar":"styles_cinnabar__d7ZcM","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate__gfvvJ","mobile-bank-application":"styles_mobile-bank-application__8x8sy","software-for-mri-interpretation":"styles_software-for-mri-interpretation__uVU3a","cedar-valley-farms":"styles_cedar-valley-farms__Gxluj","mobile-budgeting-app":"styles_mobile-budgeting-app__R49L7","forex-trading-platform":"styles_forex-trading-platform__8a5uz","crowdfunding-platform":"styles_crowdfunding-platform__Lb3LU","cctv-footage-analytics":"styles_cctv-footage-analytics__N74yG","analytics-for-carbon-tracking":"styles_analytics-for-carbon-tracking__giMLh","web-chat-for-mediums":"styles_web-chat-for-mediums__wUcJe","web-p2p-lending-platform":"styles_web-p2p-lending-platform__ajcpo","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__patKP","mobile-music-app":"styles_mobile-music-app__uEMaO","clairvoyant-directory-upgrade":"styles_clairvoyant-directory-upgrade__1Mxvk","digital-wallet-for-ios":"styles_digital-wallet-for-ios__ugOL3","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system__4dyVL","medical-software-for-musculoskeletal-rehabilitation":"styles_medical-software-for-musculoskeletal-rehabilitation__8uOvR","restaurant-asset-management-tool":"styles_restaurant-asset-management-tool__RlDLu","custom-payment-gateway":"styles_custom-payment-gateway__C5wJC","ai-documentation-processing":"styles_ai-documentation-processing__onaWM","ai-mobile-cooking-app":"styles_ai-mobile-cooking-app__WphYi","ai-based-travel-planner":"styles_ai-based-travel-planner__Gn4AW","ai-streamlined-recruitment-process":"styles_ai-streamlined-recruitment-process__ly2wD","writer-framework-platform":"styles_writer-framework-platform__WMFMY","computer-vision-for-aras":"styles_computer-vision-for-aras__31HCA","enhancing-money-laundering-mention-extraction":"styles_enhancing-money-laundering-mention-extraction__nfr_c","penetration-testing-for-healthtech-company":"styles_penetration-testing-for-healthtech-company__WDtvt","pen-testing-for-uk-web-dev-company":"styles_pen-testing-for-uk-web-dev-company__SEFDt","pen-tests-ai":"styles_pen-tests-ai___qkMq","web-logistics-platform":"styles_web-logistics-platform__bOnqL","llm-legal-document-summarization":"styles_llm-legal-document-summarization__lYdrV","ai-feedback-analysis":"styles_ai-feedback-analysis__w9kPm","ai-for-edtech":"styles_ai-for-edtech__Rb_c4","ai-reporting-assistant":"styles_ai-reporting-assistant__zVZYw","llm-for-insurtech-saas":"styles_llm-for-insurtech-saas__4DzAo","feedback-insight-engine":"styles_feedback-insight-engine__Qflwc","predictive-ai-for-marketing":"styles_predictive-ai-for-marketing__lcvoc","ai-agent-for-pre-screening":"styles_ai-agent-for-pre-screening__G3NrC","ai-concierge-for-hotel-network":"styles_ai-concierge-for-hotel-network__lT2jz","ai-voice-assistant-for-e-learning":"styles_ai-voice-assistant-for-e-learning__7mvm_","ai-assistant-for-chronic-patients":"styles_ai-assistant-for-chronic-patients__51T_y","ai-warehouse-agent":"styles_ai-warehouse-agent__hFWc9","rag-contract-intelligence-platform":"styles_rag-contract-intelligence-platform__FRhjL","claude-sonnet-leasing-operations-platform":"styles_claude-sonnet-leasing-operations-platform__ivxjp","influx":"styles_influx__UF6PL","futurepay":"styles_futurepay__o18pc","commod":"styles_commod__TOAXi"};

/***/ }),

/***/ 18907:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__y8d_O","breadcrumbs":"styles_breadcrumbs__Nidpv","writer-framework-platform":"styles_writer-framework-platform__d5Piv"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [24168,6778,57330,13107,24438,49774,92888,40179], function() { return __webpack_exec__(41910); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);